import { render, staticRenderFns } from "./AssemblyManagementUpdate.vue?vue&type=template&id=016d6f59"
import script from "./AssemblyManagementUpdate.vue?vue&type=script&lang=js"
export * from "./AssemblyManagementUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports